<template>
<div>
    <v-row align="center" class="table-title ma-1 rounded">
        <v-col>
            <p class="mb-0 table-header">Title</p>
        </v-col>
        <v-col>
            <p class="mb-0 table-header"> Status </p>
        </v-col>
        <v-col>
            <p class="mb-0 table-header"> Scheduled Date </p>
        </v-col>
        <v-col>
            <p class="mb-0 table-header"> Scheduled Time </p>
        </v-col>
        <v-col>
            <p class="mb-0 table-header">  Date Created </p>
        </v-col>
        <v-col>
            <p class="mb-0 table-header"> Actions </p>
        </v-col>
    </v-row>
    <v-row>
        <v-col v-for="detail in details.data" :key="detail.id" cols="12">
            <v-card flat class="card dt-border">
                <v-row>
                    <v-col>
                        <span>{{detail.title}}</span>
                    </v-col>
                    <v-col>
                        <span v-if="detail.status == 'active'" class="success--text">{{detail.status}}</span>
                        <span v-if="detail.status == 'inactive'" class="error--text">{{detail.status}}</span>
                    </v-col>
                    <v-col>
                        <span>{{ formatDate(detail.publicationDate) }}</span>
                    </v-col>
                    <v-col>
                        <span>{{ formatTime(detail.publicationDate) }}</span>
                    </v-col>
                    <v-col>
                        <span>{{ formatDate(detail.created) }}</span>
                    </v-col>
                    <v-col>
                        <v-btn color="blue" icon size="20" @click="action(detail,'viewDialog')" class="mr-2">
                            <v-icon>mdi-eye-outline</v-icon>
                        </v-btn>
                        <v-btn color="error" :disabled="!can('can_delete_notification')" @click="action(detail,'deleteDialog')" icon size="20">
                            <v-icon>mdi-delete-outline</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
    </v-row>
    <delete-notification @reload="reload" @closeModal="deleteDialog = false" v-if="deleteDialog" :dialog="deleteDialog" :detail="Detail" />
    <view-notification @closeModal="viewDialog = false" v-if="viewDialog" :dialog="viewDialog" :detail="Detail" />

</div>
</template>

<script>
// ============== IMPORT SERVICES ============
import { parseTimestamp, dateFormatter } from '@/utils/dates';
import DeleteNotification from '../component/delete-notification.vue';
import ViewNotification from '../component/view-notification-modal.vue'

export default {
    props:{
        details:{
            type : Object
        }
    },
    data: () => ({
        Detail : Object,
        deleteDialog : false,
        viewDialog : false,
    }),
    components:{
        DeleteNotification,
        ViewNotification
    },
    methods:{
        formatDate(date){
            return dateFormatter(date)
        },
        async action(data,modal){
            this.Detail = await data;
            this[modal] = true
        },
        formatTime(time){
            return parseTimestamp(new Date(time), 'HH:mm');
        },
        reload(){
            this.$emit('reload')
        }
    }
}
</script>
<style lang="scss" scoped>
@import './styles.scss'
</style>